import { render, staticRenderFns } from "./AnnexReport.vue?vue&type=template&id=524aa009&scoped=true"
import script from "./AnnexReport.vue?vue&type=script&lang=js"
export * from "./AnnexReport.vue?vue&type=script&lang=js"
import style0 from "./AnnexReport.vue?vue&type=style&index=0&id=524aa009&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524aa009",
  null
  
)

export default component.exports